import _ from "lodash";

export const CREATE_TICKET = "[MIS] CREATE_TICKET";
export const CREATE_TICKET_START = "[MIS] CREATE_TICKET_START";
export const CREATE_TICKET_SUCCESS = "[MIS] CREATE_TICKET_SUCCESS";
export const CREATE_TICKET_ERROR = "[MIS] CREATE_TICKET_ERROR";

export const FETCH_TICKET_DETAILS = "[TICKET] FETCH_TICKET_DETAILS";
export const FETCH_TICKET_DETAILS_START = "[TICKET] FETCH_TICKET_DETAILS_START";
export const FETCH_TICKET_DETAILS_SUCCESS = "[TICKET] FETCH_TICKET_DETAILS_SUCCESS";
export const FETCH_TICKET_DETAILS_ERROR = "[TICKET] FETCH_TICKET_DETAILS_ERROR";

export const FETCH_COMMENTS = "[TICKET] FETCH_COMMENTS";
export const FETCH_COMMENTS_START = "[TICKET] FETCH_COMMENTS_START";
export const FETCH_COMMENTS_SUCCESS = "[TICKET] FETCH_COMMENTS_SUCCESS";
export const FETCH_COMMENTS_ERROR = "[TICKET] FETCH_COMMENTS_ERROR";

export const ADD_COMMENT = "[TICKET] ADD_COMMENT";
export const ADD_COMMENT_START = "[TICKET] ADD_COMMENT_START";
export const ADD_COMMENT_SUCCESS = "[TICKET] ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_ERROR = "[TICKET] ADD_COMMENT_ERROR";


export const TICKET_DETAILS_RESET = "[TICKET] TICKET_DETAILS_RESET";

export const createTicket = (ticket) => {
    return {
        type: CREATE_TICKET,
        ticket
    };
};

export const fetchTicketDetails = (params) => {
    return {
        type: FETCH_TICKET_DETAILS,
        params
    };
};

export const fetchComments = (params) => {
    return {
        type: FETCH_COMMENTS,
        params
    };
};

export const addComment = (comment) => {
    return {
        type: ADD_COMMENT,
        comment
    };
};

export const sortComments = (comments) => {
    if (comments.length > 0) {
        return _.orderBy(comments, function (object) {
            let date = new Date(object.commentDate._seconds * 1000);
            return date;
        }, ['desc']);
    }
    return [];
};